/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: constants.ts (VIP Lists Constants)
 🗓️ Created: 2025-01-05
 🧩 Description:
    Constants and default values for VIP Lists module.

 🔧 Notes:
    - Centralized constants for better maintainability
    - Default form state values

 🔁 Last Updated: 2025-01-05 by Rodrigo Cuadra
────────────────────────────────────────────────────────────────*/

import { FormState, VIPListMember } from './types';

export const DEFAULT_FORM_STATE: FormState = {
  name: '',
  description: '',
  enabled: true,
  createdAt: null,
  updatedAt: null,
  members: []
};

export const DEFAULT_MEMBER: Omit<VIPListMember, 'id' | 'vipListId' | 'createdAt' | 'createdBy' | 'updatedAt' | 'updatedBy'> = {
  callerIdNumber: '',
  callerIdName: '',
  priority: 1,
  notes: '',
  enabled: true
};

